// List of all 66 books of the Bible (English, can be localized)
export const BIBLE_BOOK_NAMES = [
  'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy', 'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel',
  '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles', 'Ezra', 'Nehemiah', 'Esther', 'Job', 'Psalms', 'Proverbs',
  'Ecclesiastes', 'Song of Solomon', 'Isaiah', 'Jeremiah', 'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel',
  'Amos', 'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah', 'Haggai', 'Zechariah', 'Malachi',
  'Matthew', 'Mark', 'Luke', 'John', 'Acts', 'Romans', '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians',
  'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians', '1 Timothy', '2 Timothy', 'Titus', 'Philemon',
  'Hebrews', 'James', '1 Peter', '2 Peter', '1 John', '2 John', '3 John', 'Jude', 'Revelation'
];

// Category ID ranges for filtering
// Main categories: IDs 1-10 (original) and 100-110 (new categories)
// Bible book subcategories: IDs 12-77
// New category subcategories: IDs 112-199
export const MAIN_CATEGORY_MAX_ID = 11;
export const NEW_CATEGORY_MIN_ID = 100;
export const NEW_CATEGORY_MAX_ID = 110;

// Function to determine if a category should be shown in the main category screen
export function isMainCategory(category_id: number): boolean {
  // Original main categories (1-10, skip 11)
  if (category_id >= 1 && category_id <= 10) {
    return true;
  }
  
  // New main categories (100-110)
  if (category_id >= NEW_CATEGORY_MIN_ID && category_id <= NEW_CATEGORY_MAX_ID) {
    return true;
  }
  
  return false;
}
